// utilities/hotjar.ts

declare global {
    interface Window {
      hj: any; // hj কে any টাইপ দিয়ে ডিক্লেয়ার করা হয়েছে
    }
  }
  
  export function addHotjar() {
    if (window.hj) return; 
    const script = document.createElement('script');
    script.src = `https://static.hotjar.com/c/hotjar-${process.env.REACT_APP_HOTJAR_ID}.js?sv=6`;  
    document.head.appendChild(script);
  
    script.onload = () => {
      window.hj = window.hj || function () {
        (window.hj.q = window.hj.q || []).push(arguments);
      };
      window.hj('init', process.env.REACT_APP_HOTJAR_ID);  
    };
  }
  
  export function sendHotjarEvent(eventName: string, eventDetails: Record<string, any> = {}) {
    if (window.hj) {
      window.hj('event', eventName, eventDetails);  
    } else {
      console.warn('Hotjar has not been initialized');
    }
  }
  